<template>
  <app-layout>
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Artikel Blog
      </h2>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
          <div class="p-6">
            <div class="flex justify-between mb-6">
              <h3 class="text-lg font-semibold">Kelola Artikel Blog</h3>
              <Link :href="route('blog-posts.create')" 
                    class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition">
                Buat Artikel Baru
              </Link>
            </div>

            <div v-if="$page.props.flash.success" class="mb-6 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
              {{ $page.props.flash.success }}
            </div>

            <!-- Blog Posts DataTable -->
            <EzDataTable
              :config="tableConfig"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <jet-confirmation-modal :show="confirmingDeletion" @close="closeModal">
      <template #title>
        Hapus Artikel Blog
      </template>

      <template #content>
        Apakah Anda yakin ingin menghapus artikel blog ini? Tindakan ini tidak dapat dibatalkan.
      </template>

      <template #footer>
        <jet-secondary-button @click="closeModal">
          Batal
        </jet-secondary-button>

        <jet-danger-button class="ml-2" @click="deletePost" :class="{ 'opacity-25': processing }" :disabled="processing">
          Hapus
        </jet-danger-button>
      </template>
    </jet-confirmation-modal>
  </app-layout>
</template>

<script>
import { defineComponent } from 'vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import { Link } from '@inertiajs/inertia-vue3';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import EzDataTable from '@/Components/EzDataTable';
import { Inertia } from '@inertiajs/inertia';

export default defineComponent({
  components: {
    AppLayout,
    Link,
    JetConfirmationModal,
    JetDangerButton,
    JetSecondaryButton,
    EzDataTable,
  },
  data() {
    return {
      confirmingDeletion: false,
      processing: false,
      postToDelete: null,
      tableConfig: {
        dtHeader: 'Daftar Artikel Blog',
        dtSourceApiRoute: {
          list: 'blog-posts.list',
          edit: 'blog-posts.edit',
          destroy: null, // Using our own delete method
          drop: 'blog-posts.drop'
        },
        defineCols: [
          {
            field: 'heading_image_url',
            header: 'Gambar',
            col_type: 'text',
            style: 'width: 100px',
            col_display: 'image',
            isFilterAble: false,
            isSortAble: false
          },
          {
            field: 'title',
            header: 'Judul',
            col_type: 'text',
            style: 'min-width: 200px'
          },
          {
            field: 'excerpt',
            header: 'Ringkasan',
            col_type: 'text',
            style: 'min-width: 200px'
          },
          {
            field: 'user.name',
            header: 'Penulis',
            col_type: 'text',
          },
          {
            field: 'is_in_carousel',
            header: 'Tampil di Carousel',
            col_type: 'boolean',
          },
          {
            field: 'is_pinned',
            header: 'Disematkan',
            col_type: 'boolean',
          },
          {
            field: 'status',
            header: 'Status',
            col_type: 'text',
            col_display: 'badge',
            badges: [
              { text: 'Diterbitkan', class: 'bg-green-100 text-green-800' },
              { text: 'Draft', class: 'bg-yellow-100 text-yellow-800' }
            ]
          },
          {
            field: 'formatted_date',
            header: 'Tanggal',
            col_type: 'text',
          }
        ],
        globalFilter: ['title', 'excerpt', 'user.name', 'status']
      }
    };
  },
  methods: {
    confirmDelete(post) {
      this.postToDelete = post;
      this.confirmingDeletion = true;
    },
    closeModal() {
      this.confirmingDeletion = false;
      setTimeout(() => {
        this.postToDelete = null;
      }, 300);
    },
    deletePost() {
      if (!this.postToDelete) return;

      this.processing = true;
      Inertia.delete(route('blog-posts.destroy', this.postToDelete.id), {
        onSuccess: () => {
          this.closeModal();
          this.processing = false;
          // Refresh the DataTable
          this.$nextTick(() => {
            this.$refs.ezDataTable?.loadData();
          });
        },
        onError: () => {
          this.processing = false;
        }
      });
    }
  },
});
</script>
